import { render, staticRenderFns } from "./fund-list.vue?vue&type=template&id=9573a43a"
import script from "./fund-list.vue?vue&type=script&lang=js"
export * from "./fund-list.vue?vue&type=script&lang=js"
import style0 from "./fund-list.vue?vue&type=style&index=0&id=9573a43a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports